import * as React from 'react';
import { createRoot } from 'react-dom/client';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import IReactEvent from 'PyzShopUi/scripts/interfaces/article-list/IReactEvent';
import { ProductLocalStoreAvailabilityEvent } from 'PyzShopUi/scripts/react/common/events/productLocalStoreAvailabilityEvent';
import Component from 'ShopUi/models/component';
import ProductLocalStoreAvailabilityShortInfoComponent from './product-local-store-availability-short-info-component';
import {
    LocalStoreArticleAvailabilityResponse,
    ProductLocalStoreUpdateDataPayload
} from '../../organisms/product-local-store-availability/interface';
import {
    changeLocalStoreAvailabilityButtonConcreteId
} from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/localStoreAvailabilityButton';

export default class ProductLocalStoreAvailabilityShortInfo extends Component {

    protected init() {
        const productLocalStoreAvailabilityShortInfoElement: HTMLElement = document.querySelector('.product-local-store-availability-short-info');

        if (!productLocalStoreAvailabilityShortInfoElement) {
            return;
        }
        const productLocalStoreAvailabilityShortInfoElementRoot = createRoot(productLocalStoreAvailabilityShortInfoElement);

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<{}>) => {
            if (event.type !== ProductLocalStoreAvailabilityEvent.UPDATE_CONCRETE) {
                return;
            }
            productLocalStoreAvailabilityShortInfoElementRoot.render(<React.Suspense fallback=""><ProductLocalStoreAvailabilityShortInfoComponent showLocalStoreAvailability={false} disabled={false} concreteId={event.payload} /></React.Suspense>);

            const selectedStoreId = productLocalStoreAvailabilityShortInfoElement.dataset.selectedStoreId;
            const showLocalStoreAvailability = !!selectedStoreId;
            if (showLocalStoreAvailability) {
                const concreteId = event.payload;
                MiddlewareEventBus.getInstance().publish({type: ProductLocalStoreAvailabilityEvent.FETCH_DATA, payload: {concreteId}});
            }
        });

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<ProductLocalStoreUpdateDataPayload>) => {
            if (event.type !== ProductLocalStoreAvailabilityEvent.UPDATE_DATA) {
                return;
            }

            const concreteId: string = event.payload.concreteId;
            const data: LocalStoreArticleAvailabilityResponse = event.payload.data;
            const selectedStoreId: string = event.payload.selectedStoreId;
            productLocalStoreAvailabilityShortInfoElement.dataset.selectedStoreId = selectedStoreId;
            productLocalStoreAvailabilityShortInfoElementRoot.render(<React.Suspense fallback=""><ProductLocalStoreAvailabilityShortInfoComponent showLocalStoreAvailability={true} disabled={false} concreteId={concreteId} data={data} /></React.Suspense>);
        });

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<{}>) => {
            if (event.type !== ProductLocalStoreAvailabilityEvent.DISABLE) {
                return;
            }
            productLocalStoreAvailabilityShortInfoElementRoot.render(<React.Suspense fallback=""><ProductLocalStoreAvailabilityShortInfoComponent showLocalStoreAvailability={false} disabled={true} /></React.Suspense>);
        });

        const concreteIdDom = productLocalStoreAvailabilityShortInfoElement.dataset.selectedConcreteId;

        if (concreteIdDom) {
            changeLocalStoreAvailabilityButtonConcreteId(concreteIdDom);
        }
    }

    protected readyCallback(): void {
    }
}
